module.exports = __webpack_public_path__ + "img/avada-food-logo-mob.e90496d3.png";